<ion-header>
  <!-- <ion-navbar>
    <ion-title text-center>
      {{ 'CHECK_IN' | translate }}
    </ion-title>
  </ion-navbar> -->
    <ion-toolbar class="shadow">
      <ion-buttons slot="start" *ngIf="previousUrl">
        <ion-back-button [defaultHref]="previousUrl" (click)="navCtrl.back()"></ion-back-button>
      </ion-buttons>
      <ion-title class="ion-text-center">
        <!-- <div style="padding-top:15px;padding-bottom:15px; display: flex; justify-content: center;"> -->
          {{ 'CHECK_IN' | translate }}
        <!-- </div> -->
      </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
  <div #saveqrcode id="saveqrcode" >
    <img [src]="url" class="qrcode">
  </div>
  <!-- <img #saveqrcode id="saveqrcode" [src]="url" class="qrcode"> -->

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button fill="clear" (click)="saveImage()">
      <ion-icon name="bookmark"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>